<template> 
    <div class="listingTableContainer">
        <div class="listingTable" v-show="sortedRecords.length > 0">
            <table class="listing">
                <thead>
                    <tr>
                        <template v-for="(column, index) in columns" :key="index">
                            <th>
                                <span v-html="column.headerDisplayName"></span>
                                <i v-if="column.columnType !== 'buttons' && showSorting" class="fa-solid" :class="sortBy === column.fieldName ? sortIcon : 'fa-minus'" @click="changeSort(column.fieldName)"></i>
                            </th>
                        </template>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, rowIndex)  in sortedRecords" :key="rowIndex" @[clickEvent]="selectRow(row)" :class="isSelect ? 'hasHover' : null">
                        <template v-for="(column, index1) in columns" :key="index1" >
                            <td v-if="column.columnType !== 'buttons'" :style="{'width': column.width, 'text-align': column.horizontalAlign}"
                                :class="column.isEditLink ? 'link' : ''" v-on="actions.onEdit ? { click: () => editRow(row) } : {}">
                                <span v-if="Array.isArray(row[column.fieldName])">{{ row[column.fieldName].join(", ") }}</span>
                                <a v-else-if="column.isEditLink && !actions.onEdit && !isSelect" v-html="row[column.fieldName]" :href="getHref(row)"></a>
                                <span v-else-if="column.isDate" v-html="getDateString(row[column.fieldName])"></span>
                                <span v-else v-html="row[column.fieldName]"></span>
                                <span class="deletedMessage">{{ index1 === 0 && row.isActive != null && !row.isActive ? '(deleted)' : '' }}</span> 
                            </td>
                            <td class="buttonsCell" v-if="column.columnType == 'buttons'" :style="{'width': column.width, 'text-align': column.horizontalAlign}">
                                <div>
                                    <button v-if="checkField(row, column.showEditFieldName)" class="gridButton" @click="editRow(row)" title="Edit"><i class="fa-solid fa-pen-to-square"></i></button>     
                                    <button v-if="checkField(row, column.showDeleteFieldName)" class="gridButton" @click="deleteRow(row)" title="Deactivate"><i class="fas fa-trash-can"></i></button>
                                    <button v-if="checkField(row, column.showUndeleteFieldName)" class="gridButton" @click="reactivateRow(row)" title="Reactivate"><i class="fa-solid fa-trash-restore"></i></button>        
                                    <button v-if="checkField(row, column.showListingFieldName)" class="gridButton" @click="showListing(row)" title="Show Listing"><i class="fa-regular fa-rectangle-list"></i></button>
                                    <button v-if="checkField(row, column.showCopyFieldName)" class="gridButton" @click="copyRow(row)" title="Copy"><i class="fa-duotone fa-solid fa-copy"></i></button>
                                    <ItemModal v-if="column.itemModalRows"
                                                :openModalButton="createGridButton(column.openModalButton)"
                                                :formRows="column.itemModalRows"
                                                :saveItemFunction="column.saveItemFunction"
                                                :itemName="column.itemName"
                                                :passThruObject="row"></ItemModal>
                                </div>
                                
                            </td>
                        </template>
                    </tr>
                </tbody>
            </table>
            <div class="pagesRow">
                <div class="pages" v-if="showPaging">
                    <i class="fa-solid fa-angle-left pageNumber" @click="prevPage" v-show="canGoBack"></i>&nbsp;&nbsp;
                    <template v-for="page in pages" :key="page">
                        <div class="pageNumber" :class="page === currentPage ? 'inactivePageNumber' : 'activePageNumber'"
                            v-on="page != currentPage ? { click: () => changePage(page) } : {}"
                        >{{ page }}</div>
                    </template>
                    <i class="fa-solid fa-angle-right pageNumber" @click="nextPage" v-show="canGoNext"></i>
                </div>
                <div v-if="showPaging">
                    <select v-model="pageSize">
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="-1">All</option>
                    </select> Records Per Page
                </div>
                <div v-if="showFilterCount"> 
                    <div v-show="filterCriteria.length === 0">{{ this.records.length}} total record(s)</div>
                    <div v-show="filterCriteria.length > 0">{{ this.filteredRecords.length}} filtered record(s)</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {sorting} from '@/shared/sorting';
import ItemModal from '@/components/ItemModal.vue';

export default {
    name: 'ListingTable',
    components: { ItemModal },
    props: {
        intitializationParameters: {
            sortDirection: null,
            sortBy: null,
            currentPage: null,
            pageSize: null,
            showPaging: null,
            showFilterCount: null,
            showSorting: null
        },
        actions: {
            onLoadData: null,
            onDelete: null,
            editHrefBuilder: null,
            onEdit: null, 
            onUndelete: null,
            onSelect: null,
            onShowListing: null,
            onCopy: null
        },
        columns: {
            type: Array
        },
        filterCriteria: {
            type: Array,
            default: () => []
        },
        data: null
    },
    data: function() {
        return {
            sortDirection: "asc",
            sortBy: null,
            currentPage: 1,
            pageSize: 30,
            item: {},
            records: [],
            showPaging: true,
            showFilterCount: true,
            showSorting: true,
            months: [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'June',
                'July',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec'
            ]
        }
    },
    computed: {
        isSelect() {
            if(this.actions.onSelect != null)
                return true;
            else
                return false;
        },
        clickEvent() {
            return this.isSelect ? 'click' : null;
        },
        canGoBack() {
            if(this.filteredRecords)
                return this.currentPage > 1 && this.filteredRecords.length > 0;
            else 
                return false;
        },
        canGoNext() {
            if(this.filteredRecords)
                return this.currentPage < Math.ceil(this.filteredRecords.length / this.pageSize)
            else
                return false; 
        },
        sortIcon() {
            if(this.sortDirection === "desc") return "fa-caret-down";
            else 
                return "fa-caret-up";
        },
        filteredRecords() {
            var records = this.records;

            if(this.filterCriteria)
            {
                //check filter
                for(var i = 0; i < this.filterCriteria.length; i++) {
                    var criteria = this.filterCriteria[i];
                    //check for string filter

                    if(criteria.dataType === "String") {
                        if(Array.isArray(criteria.value)) {
                            records = records.filter((search) => {
                                for(let i = 0; i < criteria.value.length; i++) {
                                    if(search[criteria.fieldName].toUpperCase() === criteria.value[i].toUpperCase())
                                        return true;
                                }

                                return false;
                            });                        
                        }
                        else 
                            records = records.filter((search) => search[criteria.fieldName].toUpperCase().indexOf(criteria.value.toUpperCase()) >= 0 );                
                    }

                    if(criteria.dataType === "MultiString") {
                        records = records.filter((search) => {
                            for(let i = 0; i < criteria.fieldNames.length; i++) {
                                if(search[criteria.fieldNames[i]].toUpperCase().indexOf(criteria.value.toUpperCase()) >= 0)
                                    return true;
                            }
                        })
                    }

                    if(criteria.dataType === "StringArray") {
                        if(criteria.value.length) {
                            for(let i = 0; i < criteria.value.length; i++) {
                                records = records.filter((search) => {
                                    if(Array.isArray(search[criteria.fieldName]))
                                        for(let x = 0; x < search[criteria.fieldName].length; x++) {
                                            if(search[criteria.fieldName][x].toUpperCase() === criteria.value[i].toUpperCase())
                                                return true;
                                        }
                                    else 
                                        return search[criteria.fieldName].toUpperCase() === criteria.value[i].toUpperCase();
                                });
                            }
                        }
                    }

                    if(criteria.dataType === "Boolean")
                        records = records.filter(search => search[criteria.fieldName] === criteria.value);
                }
            }
            return records;
        },
        sortedRecords () {
            return sorting.sortArray(this.filteredRecords, this.sortBy, this.sortDirection, Number(this.pageSize), this.currentPage);
        },
        pages() {
            var pages = [];
            for(var i = 0; i < Math.ceil(this.filteredRecords.length / this.pageSize); i++) {
                pages.push(i+1)
            }
             if(pages.length === 1) pages = [];
            return pages;

        }
    },
    mounted() {
        if(this.intitializationParameters) {
            this.sortBy = this.intitializationParameters.sortBy ?? this.sortBy;
            this.sortDirection = this.intitializationParameters.sortDirection ?? this.sortDirection; 
            this.pageSize = this.intitializationParameters.pageSize ?? this.pageSize;
            this.currentPage = this.intitializationParameters.currentPage ?? this.currentPage;
            this.showSorting = this.intitializationParameters.showSorting ?? true;
            this.showPaging = this.intitializationParameters.showPaging ?? true;
            this.showFilterCount = this.intitializationParameters.showFilterCount ?? true;

             if(!this.sortBy && this.columns) 
                this.sortBy = this.columns[0].fieldName;

            if(this.data) 
                this.records = this.data;
        }
        
        this.getRecords();
    },
    methods: {
        checkField(row, fieldName) {
            if(fieldName == null) return false;
            if(fieldName === 'true') return true;


            var isNot = (fieldName.slice(0,1) === '!');
            if(isNot) 
                fieldName = fieldName.slice(1);

            if(row[fieldName] != null) {    
                if(isNot) 
                    return !(row[fieldName] === true);
                else 
                    return (row[fieldName] === true);            
            }
            else 
                return false;
        },
        showListing(row) {
            if(this.actions.onShowListing)
                return this.actions.onShowListing(row);
        },
        changePage: function(newPage) {
            this.currentPage = newPage;
        },
        getRecords: async function() {
            if(this.actions.onLoadData) {
                this.records = await this.actions.onLoadData();
            }
        },
        nextPage:function() {
            this.currentPage++;
        },
        prevPage:function() {
            if(this.currentPage > 1) this.currentPage--;
        },
        changeSort: async function(sortField) {
            if(this.sortBy != sortField ) {
                this.sortBy = sortField;
                this.sortDirection = "asc";
            }
            else {
                if(this.sortDirection == "asc") this.sortDirection = "desc";
                else 
                    this.sortDirection = "asc";
            }
        },
        deleteRow: async function(row) {
          if(this.actions.onDelete) {
            var retVal = await this.actions.onDelete(row);
            if(retVal && !this.actions.onUndelete)
                this.records = this.records.filter((search) => search.id != row.id);
          }
        },
        editRow: async function(row) {
          if(this.actions.onEdit)
            await this.actions.onEdit(row);
        },
        getHref: function(row) {
          return this.actions.editHrefBuilder(row);
        },
        reactivateRow: async function(row) {
          if(this.actions.onUndelete)
            await this.actions.onUndelete(row);
        },
        selectRow: async function(row) {
            if(this.actions.onSelect)
                await this.actions.onSelect(row);
        },
        createGridButton: function(innerHtml) {
            return '<button class="gridButton">' + innerHtml + '</button>';
        },
        copyRow: async function(row) {
            if(this.actions.onCopy)
                await this.actions.onCopy(row);
        },
        getDateString: function(dt) {
            return (new Date(dt)).toLocaleDateString();
        }
    }
}
</script>

<style scoped src="@/assets/css/shared/listingTable.css"></style>